// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"FieldSwitch__wrapper___HBEcN","input":"FieldSwitch__input___1_pqL","switch":"FieldSwitch__switch___1N4Dg","switch-on":"FieldSwitch__switch-on___3X6mA FieldSwitch__switch___1N4Dg","ball":"FieldSwitch__ball___AFJF0","ball-on":"FieldSwitch__ball-on___1bgB3 FieldSwitch__ball___AFJF0","label":"FieldSwitch__label___2pUzZ _typography__smallInfo___e4AsH _typography__headers___eO5yD","label-on":"FieldSwitch__label-on___3z68X FieldSwitch__label___2pUzZ _typography__smallInfo___e4AsH _typography__headers___eO5yD"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Form/FieldSwitch.scss
// module id = 534
// module chunks = 0